import React from "react"
import { Col, Container, Row } from "reactstrap"

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col md={6}>{new Date().getFullYear()} © Vomoz</Col>
            <Col md={6}>
              <div className="text-sm-right d-none d-sm-block">
                4.0.1 (1031)
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
